<template>
  <div class="u-display-flex u-justify-content-between">
    <div>TMS COOL ZONE APP © {{ new Date().getFullYear() }}</div>
    <div>
      <a href="https://tmsgrup.com" target="_blank">
        <img src="@/assets/images/Logo.webp" alt="logo" width="80" />
      </a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
